import styled from "styled-components";

export const AppPurchaseDisableContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
`;

export const AppPurchaseDisableContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.topbar};
  padding: 20px;
  border-radius: 8px;

  :hover:not(:disabled) {
    cursor: pointer;
  }
`;

const Text = styled.h2`
  color: ${({ theme }) => theme.colors.textColor} !important;
  font-size: 1rem;
  margin: 0;
`;

export const Title = styled(Text)`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  svg {
    color: ${({ theme }) => theme.colors.primary} !important;
    margin-right: 10px;
    font-size: 1.2rem;
  }
`;

export const BtnText = styled(Text)`
  display: flex;
  align-items: center;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.topbarText} !important;

  svg {
    align-self: flex-start;
    margin-right: 10px;
    font-size: 1.2rem;
    height: 1.5rem;
  }
`;
